<div class="timeline-node" [ngClass]="customClass" [class.timeline-node--last]="isLast">
  <span class="node-dot" [ngClass]="getDotClass()">
    <span class="node-dot-inner"></span>
  </span>
  <div class="node-content">
    <div class="node-row" *ngIf="title || time">
      <span class="node-title" [ngClass]="getTitleClass()" *ngIf="title">{{ title }}</span>
      <span class="node-time font-title" *ngIf="time">{{ time }}</span>
    </div>
    <p [ngClass]="isNote ? 'node-note-body' : 'node-body'" *ngIf="description">{{ description }}</p>
    <ng-content></ng-content>
  </div>
</div>
